module.exports = __webpack_public_path__ + "static/img/crown.dd93f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/crown.png
// module id = kvG9
// module chunks = 0